import { contentQueryKeys } from 'actions/content';
import useFetchList from 'actions/useFetchList';
export default function useFetchMySharedContent() {
  return useFetchList('me/shared', null, {
    queryKey: contentQueryKeys.mySharedContent,
    staleTime: 5 * 60 * 1000
  });
}